module.exports = require('./helpers/bundle-url').getBundleURL('15Vj6') + "edit-btn.d5d3769a.png";